import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions';
import {API_URL} from '../../../constants';
import {updateValueInJson, showModalPageClass, hideModalPageClass, validateAccesoGeneral, getRoles, esUrl} from '../../../functions';
import axios from 'axios';
import CKEditor from 'ckeditor4-react';
import $ from 'jquery';
import ModalMultimedia from '../../Partials/ModalMultimedia';

export default class EditarCategoriaPotencialExportador extends Component {

    constructor(props) {

        super(props);

        this.state = {
            key: 0,
            tituloLongitud:0,
            resource: {
                cpex_Nombre:"",
                cpex_Icono:"",
                pexp_Contenido: "",
                cpex_VideoYoutube:"",
                cpex_Fase:"",
                cpex_CategoriaSuperior:0,
                cpex_Orden:0,
                pexp_Id:0,
                cpex_Activo:true
            },
            Validacion: {
                cpex_Nombre: {
                    Error: false,
                },
                cpex_Icono: {
                    Error: false,
                },
                cpex_Fase: {
                    Error: false,
                },
                cpex_VideoYoutube: {
                    Error: false,
                },
                cpex_CategoriaSuperior: {
                    Error: false,
                },
                cpex_Orden: {
                    Error: false,
                }
            },
            categorias: [],
            hasError:false,
            hasErrorProceso:false,
            added: false,
            security: cookie.load('user'),
            roles: [],
            fieldReturnMultimedia:"",
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onEditorChange = this.onEditorChange.bind(this);
        this.getResponse = this.getResponse.bind(this);
      }

    getResponse = (urlSeleccionada) => {
        let resource = this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;

        if(fieldReturn!== ""){

            resource[fieldReturn] = urlSeleccionada;

            this.setState({resource:resource, fieldReturnMultimedia:""});
        }

        hideModalPageClass("divGestorArchivosMultimedia");
    }

    showModalMultimedia = (clase = "", campo = "") => {
        this.setState({fieldReturnMultimedia:campo});
        showModalPageClass(clase);
    }

    onEditorChange( evt ) {
        let stateResource = this.state.resource;
        stateResource.pexp_Contenido = evt.editor.getData();
        this.setState( {
            resource: stateResource
        } );
    }

    componentDidMount()
    {
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/categorias-potencial-exportador";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol);

        const url = `${API_URL}CategoriaPotencialExportadorUX/Recursos`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){
                this.setState({
                    categorias: data.result.categorias
                });
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    componentWillMount(){

        var key = this.props.match.params.id;
        const url = `${API_URL}CategoriaPotencialExportadorUX/Seleccionar/${key}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            this.setState({ resource: data.result, response: data, error: data.Error });

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });

    }

    handleClickCancel(e) {
        if(e != undefined){
            e.preventDefault();
        }
        const {history: {push}} = this.props;
        push('/categorias-potencial-exportador');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.cpex_Nombre == '') {
            newState.Validacion.cpex_Nombre = {Error: true};
            newState.hasError = true;
        }

        if(newState.resource.is_padre){
            if (newState.resource.cpex_VideoYoutube == '') {
                newState.Validacion.cpex_VideoYoutube = {Error: true};
                newState.hasError = true;
            }
            if (newState.resource.cpex_Fase == '') {
                newState.Validacion.cpex_Fase = {Error: true};
                newState.hasError = true;
            }
        }else{
            if (newState.resource.cpex_Icono == '' || !esUrl(newState.resource.cpex_Icono))
			{
                newState.Validacion.cpex_Icono = {Error: true};
                newState.hasError = true;
            }

            if (newState.resource.cpex_CategoriaSuperior == 0) {
                newState.Validacion.cpex_CategoriaSuperior = {Error: true};
                newState.hasError = true;
            }
        }

        if (newState.resource.cpex_Orden == '') {
            newState.Validacion.cpex_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}CategoriaPotencialExportadorUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'cpex_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url,
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {
            if (data.data.isSucess)
            {
                let stateResponse = this.state;

                stateResponse.added = true;

                this.setState(stateResponse);

                setTimeout(() => {
                    this.handleClickCancel();
                }, 1000);

                setTimeout(() => {
                    this.setState({added:false});
                }, 5000);

            } else
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => {
                    this.setState({hasErrorProceso:false});
                }, 3000);
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,
        }

        if(target.name == 'cpex_Nombre'){
            tituloLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            Validacion: validaciones
        });
    }

    render() {
        return (
            <div class="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Editar Categoría Potencial Exportador</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                Categoría Potencial Exportador
                </div>

                {
                    this.state.hasErrorProceso ?
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar la actualización.</div>
                        </div>
                    </div> : null
                }

                {
                    this.state.added ?
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se actualizó el registro correctamente. Se redireccionará al listado.</div>
                        </div>
                    </div>: null
                }

                <div className="div_Modulos_Noticias">
                    {
                        (! this.state.resource.is_padre)?
                            <div className="txtFile x-1">
                                    <select name='cpex_CategoriaSuperior' id='cpex_CategoriaSuperior' onChange={this.handleInputChange} className={this.state.Validacion.cpex_CategoriaSuperior.Error ? "error" : ""}>
                                        <option value="0">Categoría Superior</option>
                                        {
                                            this.state.categorias.length > 0 ?
                                            this.state.categorias.map((categoria) => (
                                                <option value={categoria.id} selected={this.state.resource.cpex_CategoriaSuperior == categoria.id ? true : false}>{categoria.nombre.toUpperCase()}</option>
                                            ))
                                            : null
                                        }
                                    </select>
                            </div>
                        : null
                    }


                    <div className="txtFile x-1">
                        <input type="text" placeholder="Categoría" name='cpex_Nombre' value={this.state.resource.cpex_Nombre} maxLength={100} className={this.state.Validacion.cpex_Nombre.Error ? "error" : ""}
                        onChange={this.handleInputChange}/>
                        <span data-length={100}>{this.state.tituloLongitud}/100</span>
                    </div>

                    {
                        (! this.state.resource.is_padre) ?
                        <React.Fragment>
                        <CKEditor
                        data={this.state.resource.pexp_Contenido}
                        onChange={this.onEditorChange}
                        />
                        <div className="txtFile x-1">
                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosMultimedia", "cpex_Icono")}/>
                            <input type="text" placeholder="Icono" name='cpex_Icono' value={this.state.resource.cpex_Icono} className={this.state.Validacion.cpex_Icono.Error ? "error" : ""}
                            onChange={this.handleInputChange}/>
                        </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Enlace Youtube" name='cpex_VideoYoutube' value={this.state.resource.cpex_VideoYoutube} className={this.state.Validacion.cpex_VideoYoutube.Error ? "error" : ""}
                            onChange={this.handleInputChange}/>
                        </div>
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Fase" name='cpex_Fase' value={this.state.resource.cpex_Fase} className={this.state.Validacion.cpex_Fase.Error ? "error" : ""}
                            onChange={this.handleInputChange}/>
                        </div>
                        </React.Fragment>
                    }


                    <div className="txtFile x-2">
                        <input type="text" placeholder="Orden" name='cpex_Orden' value={this.state.resource.cpex_Orden} maxLength={2} className={this.state.Validacion.cpex_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />
                <ModalMultimedia class="divGestorArchivosMultimedia" callback={this.getResponse.bind(this)}/>
            </div>
        )
    }
}
